var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.5C11.3667 0.5 8.78329 3.94451 7.75 10.8333C9.3 7.38882 11.1083 6.09715 13.175 6.95833C14.3541 7.44957 15.1969 8.87545 16.1298 10.4535C17.6495 13.0245 19.4083 16 23.25 16C27.3833 16 29.9667 12.5555 31 5.66667C29.45 9.11118 27.6417 10.4028 25.575 9.54167C24.3959 9.05043 23.5531 7.62455 22.6202 6.0465C21.1005 3.47548 19.3417 0.5 15.5 0.5ZM7.75 16C3.61671 16 1.03329 19.4445 0 26.3333C1.55 22.8888 3.35829 21.5972 5.425 22.4583C6.60409 22.9496 7.4469 24.3754 8.37981 25.9535C9.89954 28.5245 11.6583 31.5 15.5 31.5C19.6333 31.5 22.2167 28.0555 23.25 21.1667C21.7 24.6112 19.8917 25.9028 17.825 25.0417C16.6459 24.5504 15.8031 23.1245 14.8702 21.5465C13.3505 18.9755 11.5917 16 7.75 16Z",
    fill: "url(#paint0_linear_635_218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_635_218",
    x1: -0.86118,
    y1: 10.42,
    x2: 31,
    y2: 21.4424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.4a6d4f21cf975795adfa6184d541f5ce.svg";
export { ForwardRef as ReactComponent };